import React, { useEffect, useState} from "react";
import store from "@/redux/store";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Switch,Label, Field } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

import { Detail as CustomerCompany } from "@/views/base/company/Detail";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { useNavigate, Link } from "react-router-dom";

import {CogIcon} from '@heroicons/react/24/outline'
import {MapTree} from '@/components/tree/Maps';
import { StorageRights } from "./StorageRights";

export function RoleDetail({...props})  {
  const { register, handleSubmit, watch, reset,    formState, setValue, getValues } = useForm({
      defaultValues: props.data.selected,
      values: props.data.selected
    })
    
const tabs = [
  {id: 1, name: 'Menu rechten', href: '#', icon: CogIcon, current: true },
  {id: 2, name: 'Bestandsrechten', href: '#', icon: CogIcon, current: false },
]
const [selectedTab, setSelectedTab] = useState(1)
const [selectedMap, setSelectedMap] = useState(null);
const [selectedItems, setSelectedItems] = useState(false);

    const selectedStorageAbility = (selectedMap) ? getValues('storage.'+selectedMap?.id) : null;
    
    const abilities = (props?.data?.selected?.abilities) ? props?.data?.selected?.abilities : [];
   const onSubmit: SubmitHandler<any> = (data) => {
    
    if(props.onSaveHandler) {
        props.onSaveHandler(data);
    }
      
    return false;

    }
    
const setRole=(data) => {
    if(props?.getValues) {
        props.setValue("roles", data);
    }
    setSelected(data);
}
    
    
function getAllRoleValues() {
    return getValues();
}
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const handlerSelectedTab =(selectedTabId) => {
    setSelectedTab(selectedTabId);
    
    //return false;
}
    const mapSelected =(item, selectedItems) => {
        setSelectedMap({...item});
        setSelectedItems(selectedItems);
        
        return false;
    }
    const setAllChildsSame=(item, mapRights, isOn) => {
        if(!getValues('storage')) {
            setValue('storage', {});
         }
        
         let object = {id: item.id, path: item.path, mapRights: null, fileRights: null, rightsOnChild: false};
         if(getValues('storage.'+item.id)) {
             object = getValues('storage.'+item.id);
         }
         if(mapRights) {
             object.mapRights = mapRights;
         }
             object.rightsOnChild = isOn;
        setValue('storage.'+item.id, object, {shouldDirty: true});
    }  
    
    
    const setAbilitiesForStorage=(item, mapRights, fileRights) => {
        if(!item) return;
        if(!getValues('storage')) {
            setValue('storage', {});
         }
            if(mapRights.id ==0) {
                let storageObj = getValues('storage');
                delete storageObj[item.id];
                setValue('storage', storageObj);
                return; 
            }
            
         let object = {id: item.id, path: item.path, mapRights: null, fileRights: null, rightsOnChild: false};
         if(getValues('storage.'+item.id)) {
             object = getValues('storage.'+item.id);
         }
         if(mapRights) {
             object.mapRights = mapRights;
         }
         if(fileRights) {
             object.fileRights = fileRights;
         }
         
        setValue('storage.'+item.id, object, {shouldDirty: true});
        
        //}
    }

const [enabled, setEnabled] = useState(false)
const roles = store.getState()?.UserReducer['roles'];
const [selected, setSelected] = useState(getValues("roles"));



   return (
    <>


    <div className="space-y-10 divide-y divide-gray-900/10">
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSubmit)}>

                  <input
                    id="key"
                    name="key"
                    type="hidden"
                    {...register("key")}
                    key={(props?.data && props?.data?.key) ?? null} />
 
 
 
          { !props?.noRoleName && 
                <div className="grid grid-cols-12 gap-1 my-4 px-4">
                
                
                
                    <div className="col-span-12 sm:col-span-8">
            <FieldHolder colspan="8" smcolspan="5" label="Rol naam" id="name" error={props?.state?.error}>                
                  <input
                    id="name"
                    type="text"
                    {...register("name")}
                    key={(props?.data?.name) ?? null}
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            
                  </div>
          <div className="flex items-center justify-end gap-x-6 px-4 py-4 sm:px-8 col-span-4">
            <Link to="/roles" type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
          </div>
          }

      <div className="flow-root my-4 px-4">
              
          <div className="hidden sm:block">
            <div className="border-b border-gray-200">
              <nav aria-label="Tabs" className="-mb-px flex space-x-8">
                {tabs.map((tab) => (
                  <a
                    key={tab.name}
                    href={tab.href}
                    onClick={() => handlerSelectedTab(tab.id)}
                    aria-current={tab.id == selectedTab ? 'page' : undefined}
                    className={classNames(
                      tab.id == selectedTab
                        ? 'border-indigo-500 text-indigo-600'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                      'group inline-flex items-center border-b-2 px-1 py-4 text-sm font-medium',
                    )}
                  >
                    <span>{tab.name}</span>
                  </a>
                ))}
              </nav>
            </div>
          </div>
          
          {selectedTab == 1 &&
        <div className="">
          <div className="inline-block min-w-full py-2 align-middle">
            <table className="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8"
                  >
                    Rechten
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 hidden border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:table-cell"
                  >
                    Alle
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 hidden border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:table-cell"
                  >
                    Bekijken
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 hidden border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:table-cell"
                  >
                    Aanmaken
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter"
                  >
                    Bewerken
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter"
                  >
                    Verwijderen
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(abilities).map((item, index) => (

                 <tr key={item}>
                    <td
                      className={classNames(
                        index !== Object.keys(abilities).length - 1 ? 'border-b border-gray-200' : '',
                        'whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8',
                      )}
                    >
                      {item}
                    </td>
                
                    {Object.keys(abilities[item]).map((item2, index2) => (

                    <td key={item+item2}
                      className={classNames(
                        index !== Object.keys(abilities).length - 1 ? 'border-b border-gray-200' : '',
                        'whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8',
                      )}
                    >
                        <input
                          type="checkbox"
                          defaultChecked={abilities[item][item2]?.selected == 1}
                          {...register("abilities."+item+"."+item2+".selected")}
                          className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                      
                      
                    </td>
                
                
                    ))}
                    </tr>                
                ))}
              </tbody>
            </table>
          </div>
        </div>
          }
          
        {selectedTab == 2 &&          
          <div className="">
          
<main className="flex flex-1 overflow-hidden">


            {/* Primary column */}
            <section
              aria-labelledby="primary-heading"
              className="flex h-auto min-w-0 flex-1 flex-col overflow-y-auto lg:order-last p-5"
            >
                <span className="text-xs">Rechten voor de map</span> 
              <h1 id="primary-heading" className="">
                {selectedMap?.name}
              </h1>
              {selectedMap &&
              <StorageRights key={selectedMap.id} data={selectedMap} setAbilitiesForStorage={setAbilitiesForStorage} abilities={selectedStorageAbility} setAllChildsSame={setAllChildsSame}/>
              }
            </section>

            {/* Secondary column (hidden on smaller screens) */}
            <aside className="hidden p-1 lg:order-first lg:block lg:flex-shrink-0">
              <div className="relative flex h-full w-96 flex-col overflow-y-auto border-r border-gray-200 bg-white">
                <MapTree key={(selectedMap) ? selectedMap.id : "Sdf"} data={props?.data?.storage} rights={props?.data?.selected?.storage} selected={mapSelected} selectedMap={selectedMap}  />
              </div>
            </aside>
          </main>          
          
            
          </div>
        }
          
          
          
          
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to="/roles" type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
          </div>
        </form>
      </div>
      </div>


    </>
    )   
}